import { render, staticRenderFns } from "./controls.vue?vue&type=template&id=583f8860&scoped=true&"
import script from "./controls.vue?vue&type=script&lang=js&"
export * from "./controls.vue?vue&type=script&lang=js&"
import style0 from "./controls.vue?vue&type=style&index=0&id=583f8860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583f8860",
  null
  
)

export default component.exports